import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Auth } from '@angular/fire/auth';
import { IPagoPension } from "@interfaces/pagos-pension.interface";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable({ providedIn: 'root' })

export class PagoPensionService {


  public token: string = '';

  constructor(
    public firebaseAuth: Auth,
    private readonly http: HttpClient,
  ) {
  }

  public obtenerInfoPago(token: string): Observable<IPagoPension> {
    let url = `${environment.BASE_BACKEND}/pagos`;
    let headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);
    return this.http.get(url, { headers }) as Observable<IPagoPension>;
  }

  public obtenerPagoCmprobante(periodo: number, token: string, download: boolean): Observable<any> {
    let url = `${environment.BASE_BACKEND}/pagos/comprobante?movimientos=${periodo}&download=${download}`;
    let headers = new HttpHeaders().append('Authorization', `Bearer ${token}`);
    return this.http.get(url, { headers }) as Observable<any>;
  }
  
  public base64toBlob(b64Data: any, sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.codePointAt(i) || 0;
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: 'application/pdf' });
    return blob;
  }

}